import { Autocomplete, Box, MenuItem, Select, TextField } from "@mui/material";
import axios from "axios";
import { debounce, isEmpty } from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import { baseUrl } from "../../plugins/urls";


/* interface resultType {
    {
        "id": 700,
        "admin": true,
        "dateOfBirth": "2000-10-10",
        "email": "test-bolaji33@yopmail.com",
        "firstName": "AZEEZ",
        "gender": "MALE",
        "password": "********",
        "phoneNumber": "2349012222222",
        "referenceCode": "4tFvEAL1CV7CPKrX",
        "roleName": "OWNER",
        "surname": "AZ",
        "userId": "1622",
        "merchantUserId": "1622",
        "merchantId": "2WP000000000030",
        "deleted": false,
        "createdAt": [],
        "modifiedAt": [
        ],
        "menu": {}
      },
    description: string;
    structured_formatting: StructuredFormatting;
  } */

const FilterSearchMerchant = ({ setSelectedValue }) => {
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const fetch = useMemo(
    () =>
      debounce((request, callback) => {
        const { value } = request;
        if (!value) {
          callback([]);
          return;
        }

        let searchTerm = value;
        if (!value.includes("@")) {
          const digits = value.replace(/\D/g, "");
          if (digits.length === 11 && digits.startsWith("0")) {
            searchTerm = "+234" + digits.substring(1);
          }
        }
        const url = `${baseUrl().auth}/admin/users/email/${searchTerm}`;

        axios
          .get(url)
          .then((res) => {
            let results = [];
            if (res.data && res.data.data) {
              if (Array.isArray(res.data.data)) {
                results = res.data.data;
              } else if (res.data.data.content && Array.isArray(res.data.data.content)) {
                results = res.data.data.content;
              } else {
                results = [res.data.data];
              }
            }
            callback(results);
          })
          .catch((err) => {
            console.error("merchant search error", err);
            callback([]);
          });
      }, 300),
    []
  );
  useEffect(() => {
    let active = true;

    if (isEmpty(inputValue)) {
      //  setOptions(value ? [value] : []);
      return undefined;
    }

    fetch({ field: "all", value: inputValue }, (results) => {
      setOptions(results ? results : []);
    });

    return () => {
      active = false;
    };
  }, [value, inputValue, fetch]);
  return (
    <div>
      <div>Search for Merchant by email or phone number</div>
      <Autocomplete
        id="filter-search-merchant"
        multiple
        disableClearable
        getOptionLabel={(option) =>
          typeof option === "string"
            ? option
            : `${option?.firstName} ${option?.lastName} - ${option.email} - ${option.merchantId}`
        }
        options={options}
        value={value}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        onChange={(e, value) => {
          setSelectedValue(value);
          setValue(value);
        }}
        renderInput={(params) => (
          <TextField {...params} fullWidth size="small" />
        )}
      />
    </div>
  );
};

export default FilterSearchMerchant;
